
import { MultiApp } from '@/config/context';
import { BaseUser } from './base-user';
import InternalUser from './internal';
import ProUser from './pro';
import SgpUser from './sgp';
import WoaUser from './woa';


const userImplements: Record<MultiApp, any> = {
  [MultiApp.WOA]: WoaUser,
  [MultiApp.Internal]: InternalUser,
  [MultiApp.Pro]: ProUser,
  [MultiApp.Sgp]: SgpUser,
};

export const userImplement: BaseUser<any> = new userImplements[process.env.APP_VERSION as MultiApp];
